interface EAPhaseIndicatorProps {
  currentPhase: string
  compact?: boolean
}

const phases = [
  { key: 'discovery', label: 'Discovery' },
  { key: 'design', label: 'Design' },
  { key: 'standards_gate', label: 'Standards Gate' },
  { key: 'deployment', label: 'Deployment' },
  { key: 'qc', label: 'QC' },
  { key: 'deliverables', label: 'Deliverables' },
  { key: 'complete', label: 'Complete' },
]

export default function EAPhaseIndicator({ currentPhase, compact = false }: EAPhaseIndicatorProps) {
  const currentIndex = phases.findIndex((p) => p.key === currentPhase)
  const currentLabel = phases[currentIndex]?.label || currentPhase

  if (compact) {
    const dotColor = currentPhase === 'complete' ? '#10b981' : '#3b82f6'
    return (
      <span className="inline-flex items-center space-x-1.5 text-xs font-medium">
        <span
          className="w-2 h-2 rounded-full"
          style={{ backgroundColor: dotColor }}
        />
        <span style={{ color: '#e2e8f0' }}>{currentLabel}</span>
      </span>
    )
  }

  return (
    <div className="flex items-center space-x-1">
      {phases.map((phase, index) => {
        const isCompleted = index < currentIndex
        const isCurrent = index === currentIndex
        const isFuture = index > currentIndex

        return (
          <div key={phase.key} className="flex items-center">
            {/* Dot */}
            <div className="relative flex items-center justify-center">
              {isCompleted && (
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(16, 185, 129, 0.2)' }}
                >
                  <svg
                    className="w-3 h-3"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="#10b981"
                    strokeWidth={3}
                  >
                    <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              {isCurrent && (
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(59, 130, 246, 0.2)' }}
                >
                  <div
                    className="w-2.5 h-2.5 rounded-full animate-pulse"
                    style={{ backgroundColor: '#3b82f6' }}
                  />
                </div>
              )}
              {isFuture && (
                <div
                  className="w-5 h-5 rounded-full flex items-center justify-center"
                  style={{ backgroundColor: 'rgba(100, 116, 139, 0.15)' }}
                >
                  <div
                    className="w-2 h-2 rounded-full"
                    style={{ backgroundColor: 'rgba(100, 116, 139, 0.4)' }}
                  />
                </div>
              )}
            </div>

            {/* Connecting line */}
            {index < phases.length - 1 && (
              <div
                className="w-4 h-0.5 mx-0.5"
                style={{
                  backgroundColor: index < currentIndex
                    ? 'rgba(16, 185, 129, 0.4)'
                    : 'rgba(100, 116, 139, 0.2)',
                }}
              />
            )}
          </div>
        )
      })}
    </div>
  )
}
